import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../generic-components/Icon';
import { greenStatusIcon, redStatusIcon } from '../../assets/svg';
import { AVAILABLE_STATUSES } from './consts';
import { getDueDateNoticeText, getDueDateNoticeTextStyle } from './utils';
import { getNumOfOverdueDays } from '../../helpers/datesAndTime.helper';
import { isBillOverdue } from '../../pages/BillPay/features/BillsHub/utils';
import Heading from '../../generic-components/Heading';

interface IDueDateNoticeProps {
  dueDate: string,
  status: string,
  paidTime?: string,
}

const DueDateNoticeStyles = {
  Icon: 'inline-block mr-[4px] w-[12px] h-[12px]',
  Wrapper: 'flex items-center',
};

export const DueDateNotice = ({ dueDate, status, paidTime }: IDueDateNoticeProps) => {
  const { t } = useTranslation();
  const numOfOverdueDays = getNumOfOverdueDays(dueDate);
  const getDueDateNoticeIconSrc = () => {
    if (isBillOverdue(status, numOfOverdueDays)) return redStatusIcon;
    if (status === AVAILABLE_STATUSES.PAID) return greenStatusIcon;
    return null;
  };

  const text = getDueDateNoticeText(status, numOfOverdueDays, t, paidTime);
  const style = getDueDateNoticeTextStyle(status);
  const icon = getDueDateNoticeIconSrc();
  if (!text) return null;

  return (
    <div className={DueDateNoticeStyles.Wrapper}>
      {icon && <Icon className={DueDateNoticeStyles.Icon} src={icon} />}
      {text && <Heading className={style} title={text} />}
    </div>
  );
};
